import React, { useRef, useCallback, useEffect, useState } from "react"
import { Editor, EditorHandle } from "../editor/Editor"
import {
  useCommunication,
  useUpdateCommunication,
} from "../../api/communications"

interface IntroLetterTabProps {
  communicationId: string
}

const IntroLetterTab: React.FC<IntroLetterTabProps> = ({ communicationId }) => {
  const {
    data: communication,
    isLoading: communicationLoading,
    error: communicationError,
  } = useCommunication(communicationId)
  const updateCommunication = useUpdateCommunication()

  const editorRef = useRef<EditorHandle>(null)

  const onChange = useCallback(async () => {
    const content = await editorRef?.current?.getContent()
    if (!content) return

    updateCommunication.mutate({
      id: communicationId,
      intro_letter_editorjs_content: content,
    })
  }, [communicationId])

  return (
    <>
      {communicationLoading ? (
        <div className="loading-container">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading Intro Letter...</p>
        </div>
      ) : communicationError ? (
        <div className="error-container">
          <p className="text-danger">
            Error loading portfolio companies. Please try again.
          </p>
        </div>
      ) : (
        <div className="intro-letter-tab">
          <h2 className="tab-heading">Intro Letter</h2>
          <div className="pdf-editor-container">
            <div className="pdf-dimensions-helper">
              Letter size (8.5 inches) - Content will be exported as PDF
            </div>
            <div className="pdf-document">
              <Editor
                ref={editorRef}
                initialData={communication.intro_letter_editorjs_content}
                onChange={onChange}
                reportId={communication.id}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default IntroLetterTab
